/**
 * Created by wjjn3481 on 2017/7/17.
 */

import qs from 'qs'
import ExportCustomDialog from '../operation/exportCustomDialog'

export default {
    components: {
        ExportCustomDialog
    },
    data () {
        return {
            multipleSelection: []
        }
    },
    computed: {
        idStr () {
            let idsArr = this.multipleSelection.map(item => item.id)
            return idsArr.join(',')
        },
        basePath () {
            let nameToPath = {
                    'resumeList': '/resume',
                    'entryList': '/entry',
                    'interviewList': '/employ',
                    'paymentList': '/payment',
                    'writtenList': '/written'
                },
                name = (this.$route.query && this.$route.query.fromName) || this.$route.name

            return nameToPath[name] || '/employ'
        },
        employPhase () {
            let turn = (this.$route.query && this.$route.query.turn) || this.$route.params.id
            return this.basePath === '/employ' ? parseInt(turn) - 1 : ''
        }
    },
    methods: {
        customExportValid () {
            console.log(this.idStr)
            if (this.idStr === '') {
                this.$message({
                    message: '请先勾选数据',
                    type: 'warning'
                })
                return false
            }
            return true
        },
        customExportParams (phase, exportAll) {
            if(this.idStr && !exportAll) {
                return {ids: this.idStr}
            } else {
                let searchData = JSON.parse(JSON.stringify(this.$route.query))
                if (searchData.pageIndex) {
                    searchData.pageIndex = ''
                }
                if (typeof this.$route.params.id !== 'undefined') {
                    searchData.employPhase = parseInt(this.$route.params.id) - 1
                }
                return Object.assign({phase: phase}, { ...searchData })
            }
        },
        reloadList (isEmit = false) {
            if (isEmit) {
                this.$emit('reload')
            } else {
                this.fetchData()
            }
        },
        exportParamsFiles (path, type = 'EXCEL') {
            let paramsStr = qs.stringify(Object.assign({}, this.searchData, {
                pageIndex: undefined,
                pageSize: undefined
            }))
            if (path.indexOf('?') > -1) {
                path += '&'
            } else {
                path += '?'
            }
            window.open(`${this.$axios.defaults.baseURL}${path}token=${this.$store.state.app.token}&${paramsStr}&type=${type}`)
        },
        exportFiles (idStr, basePath, lastPath = '/exportResume.api', paramStr) {
            if (idStr === '') {
                this.$message({
                    message: '请先勾选数据',
                    type: 'warning'
                })
                return false
            }
            let path = basePath || this.basePath
            window.open(`${this.$axios.defaults.baseURL}${path}${lastPath}?token=${this.$store.state.app.token}&ids=${idStr}${paramStr ? ('&' + paramStr) : ''}`)
        },
        handleSelectionChange (val) {
            this.multipleSelection = val
        },
        handleCommand (command) {
            let args = command.split('/')
            console.log('command:', command, args)
            this.changeStatus.apply(this, args)
        },
        checkDataValid (data, message = '请先勾选数据', type = 'warning') {
            if (typeof data === 'number') {
                data = data + ''
            }
            if (data && data.length) {
                return true
            }
            this.$message({
                message: message,
                type: type,
            })
            return false
        },
        getHandlerUserInfo (ids) {
            let userNames = []
            if (this.lists) {
                ids.split(',').forEach(id => {
                    let user = this.lists.filter(item => String(item.id) === id)[0]
                    let name = (user.resumeForm && user.resumeForm.name) || user.name,
                        positionName = (user.positionForm && user.positionForm.name) || user.positionName
                    user && userNames.push(`${name}【${positionName}】`)
                })
            }
            let nameStr = userNames.length > 10 ? (userNames.slice(0, 9).join('、') + ' 等' + userNames.length + '人') : userNames.join('、')
            return userNames.length ? '应聘者：' + nameStr + '\n' : ''
        },
        resetInterview (ids) {
            ids = ids || this.idStr

            if (!this.checkDataValid(ids)) {
                return false
            }
            let handlerInfo = this.getHandlerUserInfo(ids)
            let str = []
            const h = this.$createElement
            str.push(h('p', {style: 'color: #888'}, `${handlerInfo}`))
            str.push(h('p', {style: 'color: #ff0000'}, `该操作将选中应聘者的简历状态重置为一面未处理，需重新安排面试。是否继续？`))
            let target = event.target
            if(target.nodeName === 'SPAN' || target.nodeName === 'I') {
                target = event.target.parentNode
            }
            target.blur()
            this.$msgbox({
                customClass: 'resume-state-wpr',
                title: `重置面试安排`,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                showCancelButton: true,
                message: h('div', null, str),
                type: 'warning'
            }).then(() => {
                this.$axios.post('/resumePosition/interviewArrange/repetInterview.api  ', {ids: ids}, {'X-showMessage': true}).then(res => {
                    this.closeWindow()
                    this.reloadList()
                }).catch(() => {
                })
            }).catch(() => {
            })
        },
        changeStatus (ids, status, url, statusText) {
            ids = ids || this.idStr

            if (!this.checkDataValid(ids)) {
                return false
            }

            let textMap = {
                    'forceToWrite': '进入笔试',
                    'pass': '通过',
                    'undetermined': '待定',
                    'notPass': '淘汰',
                    'lh': '拉黑',
                    'back': '回退',
                    'fq': '放弃',
                    'entry': '进入入职',
                    'payment': '进入定薪'
                },
                operationText = statusText || textMap[status] || ''
            let handlerInfo = this.getHandlerUserInfo(ids)
            let str = []
            const h = this.$createElement
            if (handlerInfo) {
                str.push(h('p', {style: 'color: #888'}, `${handlerInfo}`))
            }
            str.push(h('p', null, `目标状态： ${operationText}`))
            if (status === 'lh') {
                str.push(h('textarea', {
                    attrs: {id: 'state-comment-info', placeholder: '请填写备注(选填)', maxlength: 200},
                    class: 'el-textarea__inner mt-5'
                }))
            }
            if (status === 'fq' || statusText === '毁约') {
                let btn = document.querySelector('.resume-state-wpr .confirm-btn')
                if (btn) {
                    btn.classList.add('is-disabled')
                }
                str.push(h('textarea', {
                    attrs: {
                        id: 'state-comment-info',
                        placeholder: '请填写原因(必填)',
                        maxlength: 500,
                        'oninput': `
                            let btn = document.querySelector('.resume-state-wpr .confirm-btn')
                            if (!this.value) {
                                btn.classList.add('is-disabled')
                            } else {
                                btn.classList.remove('is-disabled')
                            }
                        `
                    },
                    class: 'el-textarea__inner mt-5'
                }))
            }
            let $reson = document.getElementById('state-comment-info')
            if ($reson) {
                $reson.value = ''
            }
            let target = event.target
            if(target.nodeName === 'SPAN' || target.nodeName === 'I') {
                target = event.target.parentNode
            }
            target.blur()
            this.$msgbox({
                customClass: 'resume-state-wpr',
                title: `${operationText}操作`,
                confirmButtonText: '我已确认',
                cancelButtonText: '取消',
                showCancelButton: true,
                confirmButtonClass: status === 'fq' || statusText === '毁约' ? 'is-disabled confirm-btn' : 'confirm-btn',
                message: h('div', null, str),
                type: 'warning',
                beforeClose: (action, instance, done) => {
                    let $reson = document.getElementById('state-comment-info')
                    if (action !== 'confirm') {
                        let btn = document.querySelector('.resume-state-wpr .confirm-btn')
                        btn.classList.remove('is-disabled')
                    }
                    if (action === 'confirm' && (statusText === '毁约' || status === 'fq') && $reson.value === '') {
                        return false
                        // this.$message({message: '请输入内容', type: 'error'})
                    } else {
                        done()
                    }
                }
            }).then(() => {
                let $reson = document.getElementById('state-comment-info')
                let params = {
                    ids: ids,
                    isForceToWrite: status === 'forceToWrite',
                    status: status === 'forceToWrite' ? 'pass' : status,
                    employPhase: this.employPhase
                }
                if ($reson) {
                    params.operateReason = $reson.value
                }
                this.$axios.post((url || this.basePath) + '/changeFlow.api', params, {'X-showMessage': true}).then(res => {
                    this.closeWindow()

                    // #77028 【招聘入职一体化】外包后台操作完最后一页数据时，页数重置
                    if ((['pass', 'back', 'entry', 'payment'].indexOf(status) > -1) && (this.lists.length === this.multipleSelection.length) && (this.searchData.pageIndex !== 1)) {
                        this.pageIndexChange(1)
                    } else {
                        this.reloadList()
                    }
                }).catch(() => {
                })
            }).catch(() => {
            })
        },
        remove (ids, data) {
            if (!this.checkDataValid(ids)) {
                return false
            }
            this.$confirm('是否继续删除该记录?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios.post(this.removeUrl, {ids: ids}, {'X-showMessage': true}).then((res) => {
                    this.fetchData && this.fetchData()
                }).catch(() => {
                })
            }).catch(() => {
            })
        },
        closeWindow () {
            if (this.$route.name === 'resumeDetail') {
                window.opener.refreshList()
                window.close()
            }
        },
        getPhase (status) {
            return status.substr(0, 1)
        },
        getResumeDetailUrl (id, status, from = this.$route.name) {
            return `/resume/detail/${id}/${this.getPhase(status)}?fromName=${from}`
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/operation/operationMixin.js